<template>
  <generic-modal :title="$t('onfido request')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('profile')"
              url="/onfido/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.first_name"
                :placeholder="$t('first name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.last_name"
                :placeholder="$t('last name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("start") }}</label>
            <div class="button is-rounded is-primary" @click="start">
              <span class="icon">
                <i class="fa fa-check"></i>
              </span>
              <span>{{ $t("start") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div id="onfido-mount"></div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "OnfidoRequestModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.profile_id || !v.meta.first_name || !v.meta.last_name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    start() {
      let v = this;
      let data = { ...v.meta };
      put("/onfido/request/init", data)
        .then((r) => {
          let script_element = document.createElement("script");
          script_element.src = r.js_sdk_resource;
          script_element.charset = "utf-8";
          document.body.appendChild(script_element);

          let settings = r.settings;

          let phrases = {
            // welcome: {
            //   title: "Bienvenido a Onfido",
            //   descriptions: [
            //     "Para poder continuar con el proceso de verificación, necesitamos que nos proporciones tu información personal.",
            //   ],
            // },
            // document: {
            //   title: "Verificación de documentos",
            //   descriptions: [
            //     "Por favor, sube una foto de tu documento de identidad.",
            //   ],
            //   passport: "Pasaporte",
            //   driving_licence: "Licencia de conducir",
            //   national_identity_card: "Cédula de identidad",
            //   uploadFallback: "Subir documento",
            // },
            // face: {
            //   title: "Verificación facial",
            //   descriptions: ["Por favor, graba un video de tu rostro."],
            //   uploadFallback: "Subir video",
            // },
            // complete: {
            //   title: "Proceso completado",
            //   descriptions: [
            //     "Gracias por completar el proceso de verificación.",
            //   ],
            //   message: "Gracias por completar el proceso de verificación.",
            // },
          };
          let steps = [];
          if (settings.is_welcome_active)
            steps.push({
              type: "welcome",
              options: {
                title: settings.welcome_title,
                descriptions: settings.welcome_description,
                nextButton: settings.welcome_button_text,
              },
            });
          if (settings.is_document_active)
            steps.push({
              type: "document",
              options: {
                documentTypes: {
                  driving_licence:
                    settings.document_driver_license_allowed || false,
                  national_identity_card:
                    settings.document_national_id_allowed || false,
                  residence_permit:
                    settings.document_residence_permit_allowed || false,
                },
                hideCountrySelection: settings.document_hide_country_selection,
                // showCountrySelection: false,
                // useLiveDocumentCapture: true,
                // uploadFallback: true,
                // forceCrossDevice: true,
              },
            });

          if (settings.is_face_active)
            steps.push({
              type: "face",
              options: {
                requestedVariant: settings.face_validation_type,
              },
            });
          if (settings.is_poa_active)
            steps.push({
              type: "poa",
            });

          if (settings.is_complete_active)
            steps.push({
              type: "complete",
              options: {
                message: settings.complete_message,
                submessage: settings.complete_sub_message,
              },
            });

          script_element.onload = function () {
            // console.log("initing with token", r.token);
            let onf = window.Onfido.init({
              token: r.token,
              language: {
                locale: "es_ES",
                phrases: phrases,
              },
              smsNumberCountryCode: "GT",
              containerId: "onfido-mount",
              steps: steps,
              onComplete: function (data) {
                // console.log("complete", data);

                post("/onfido/request/complete", {
                  request_id: r.request_id,
                  sdk_data: data,
                })
                  .then(() => {
                    v.$emit("success");
                    onf.tearDown();
                    v.$refs.generic_modal.close_modal();
                  })
                  .catch((error) => {
                    v.error = generate_error_message_text(error);
                  });

                // let data = {
                //   document_front: {
                //     id: "e75b5f73-3e78-43fc-9bd2-a08f6621dce1",
                //     type: "national_identity_card",
                //     side: "front",
                //   },
                //   document_back: {
                //     id: "e004e53d-238e-413d-b3cb-11fec8ff850e",
                //     type: "national_identity_card",
                //     side: "back",
                //   },
                //   face: {
                //     id: "1eff51e7-327b-4466-ac43-e7bee786333d",
                //     variant: "standard",
                //   },
                // };
              },
              onError: function (error) {
                console.error("error", error);
              },
            });
          };
        })
        .catch((error) => {
          console.error("error", error);
          v.error = generate_error_message_text(error);
        });
    },
    save() {},
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
      };
      v.error = "";
      window.jQuery("#onfido-mount").empty();
      v.$refs.profile_dropdown.clear();
    },
    set_profile(profile) {
      if (profile) {
        let v = this;
        v.meta.profile_id = profile.profile_id;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
